<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Header-->
							<div class="page_header">CAPA Effectiveness Validation</div>
							<!--Header-->
							<div class="page_main">
								<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="top" class="request-form">
									<el-form-item label="CAPA ID" class="full-width-item">
										<div class="gray-input">
											{{ info.request_id || "/" }}
										</div>
									</el-form-item>
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Status">
												<div class="gray-input">
													{{ info.status_name || '/' }}
												</div>
											</el-form-item>
											<el-form-item label="Priority">
												<div class="gray-input">
													<span v-if="info.priority == 1">High</span>
													<span v-if="info.priority == 2">Medium</span>
													<span v-if="info.priority == 3">Low</span>
													<span v-if="!info.priority">/</span>
												</div>
											</el-form-item>
											<el-form-item label="Investigator">
												<div class="gray-input">
													{{ info.investigator || '/' }}
												</div>
											</el-form-item>
										</div>
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Request Date">
												<div class="gray-input">
													{{ info.time1 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Acceptance Date">
												<div class="gray-input">
													{{ info.time2 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Start Date">
												<div class="gray-input">
													{{ info.time3 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Completion Date">
												<div class="gray-input">
													{{ info.time4 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Implementation Start Date">
												<div class="gray-input">
													{{ info.time5 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Implementation Completion Date">
												<div class="gray-input">
													{{ info.time6 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Close Date">
												<div class="gray-input">
													{{ info.pass_time || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<div class="text-tip">CAPA Description</div>
									<el-form-item label="Issue、Concern、Description of Idea or Opportunity" class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
									<!-- Investigation Activity Log -->
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Investigation Activity Log</div>
										</div>
										<el-table :data="investigationLogTableData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Activity Log Entries">
											<el-table-column prop="description" label="Description" min-width="260" sortable />
											<el-table-column prop="" label="Created Time" min-width="120" sortable>
												<template #default="scope">
													{{ initTime(scope.row.update_time) }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Last Updated" min-width="140" sortable>
												<template #default="scope">
													{{ initTime(scope.row.dateline) }}
												</template>
											</el-table-column>
											<el-table-column prop="attachment" label="Attachments" min-width="160">
												<template #default="scope">
													<div v-for="(value, index) in scope.row.filelist" :key="index" style="padding: 4px 0;">
														<a :href="value.url" target="_blank">{{ value.name }}</a>
													</div>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<!-- Solution Plan -->
									<div class="solution-plan">
										<!-- Title Bar -->
										<div class="plan-header">
											<span class="plan-title">Solution Plan</span>
											<el-button type="text" class="toggle-btn" @click="toggleAll">
												{{ allExpanded ? "Show Partial" : "Show All" }}
												<i :class=" allExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
											</el-button>
										</div>
										<!-- Content Card -->
										<div class="plan-card" v-for="(item, index) in rootCause" :key="index">
											<!-- Root Cause -->
											<section class="plan-section">
												<div class="plan-header">
													<span class="plan-title">Root Cause</span>
												</div>
												<div class="form-block">
													<el-form-item label="Root Cause Analysis Result">
														<div class="gray-input">
															{{ item.analysis_results }}
														</div>
													</el-form-item>
												</div>
												<template v-if="rootCauseExpanded == item.id || allExpanded">
													<div class="form-grid">
														<!-- Left -->
														<div class="form-col">
															<el-form-item label="Is this root cause related to a supplier??">
																<div class="gray-input">
																	{{ item.is_supplier == 1 ? 'Yes' : 'No' }}
																</div>
															</el-form-item>
														</div>
														<!-- Right -->
														<div class="form-col">
															<el-form-item label="Root Cause Supplier">
																<div class="gray-input">
																	{{ item.supplier_name }}
																</div>
															</el-form-item>
														</div>
													</div>
													<div class="custom-panel">
														<div class="panel-header">
															<div class="table-title">
																Root Cause Analysis Result Files
															</div>
														</div>
														<el-table :data="item.filelist" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Root Cause Analysis Result Files">
															<el-table-column prop="" label="Description" sortablemin-width="200">
																<template slot-scope="scope">
																	<div>{{ scope.row.description || "/" }}</div>
																</template>
															</el-table-column>
															<el-table-column prop="fileName" label="File Name" min-width="240">
																<template slot-scope="scope">
																	<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
																</template>
															</el-table-column>
														</el-table>
													</div>
												</template>
												<div v-if="!allExpanded" class="section-toggle">
													<el-button type="text" @click="rootCauseExpandedClick(item)">
														{{ rootCauseExpanded == item.id || allExpanded ? 'Collapse' : 'Expand' }} <i :class=" rootCauseExpanded == item.id || allExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
													</el-button>
												</div>
											</section>
											<!-- Separator -->
											<div class="divider"></div>
											<!-- Corrective Action -->
											<div class="plan-card" v-for="(item2, index2) in item.caparootcauseaction_list" :key="index2" style="padding-left: 30px;">
												<section class="plan-section">
													<div class="plan-header">
														<span class="plan-title">{{ item2.capa_type == 1 ? 'Corrective Action' : 'Preventive Action' }}</span>
													</div>
													<div class="form-block">
														<el-form-item label="Action Implementation Description">
															<div class="gray-input">
																{{ item2.implementation_instructions }}
															</div>
														</el-form-item>
													</div>
													<template v-if="correctiveExpanded == item2.id || allExpanded">
														<div class="form-block">
															<el-form-item label="Implementer">
																<div class="gray-input">
																	{{ item2.implementor_username }}
																</div>
															</el-form-item>
														</div>
														<div class="form-block">
															<el-form-item label="Planned Action Completion Due Date">
																<div class="gray-input">
																	{{ initTime2(item2.end_time) }}
																</div>
															</el-form-item>
														</div>
														<div class="custom-panel">
															<div class="panel-header">
																<div class="table-title">Affected Files</div>
															</div>
															<el-table :data="item2.filelist" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Affected Files">
																<el-table-column prop="" label="Description" sortable min-width="200">
																	<template slot-scope="scope">
																		<div>{{ scope.row.description || "/" }}</div>
																	</template>
																</el-table-column>
																<el-table-column prop="fileName" label="File Name" min-width="240">
																	<template slot-scope="scope">
																		<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
																	</template>
																</el-table-column>
															</el-table>
														</div>
														<div class="form-block" style="margin-top: 20px">
															<el-form-item label="Operation Verification Notes">
																<div class="gray-input">
																	{{ item2.verification_instructions }}
																</div>
															</el-form-item>
														</div>
													</template>
													<div v-if="!allExpanded" class="section-toggle">
														<el-button type="text" @click="correctiveExpandedClick(item2)">
															{{ correctiveExpanded == item2.id || allExpanded ? 'Collapse' : 'Expand' }} <i :class=" correctiveExpanded == item2.id || allExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
														</el-button>
													</div>
												</section>
											</div>
										</div>
									</div>
									<div class="custom-panel">
										<div class="panel-header">
											<div class="table-title">CAPA Effectiveness ValidationTask History</div>
										</div>
										<el-table :data="taskList" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Data">
											<el-table-column prop="task" label="Additional Notes" sortable />
											<el-table-column prop="status" label="TaskStatus/Result" sortable>
												<template slot-scope="scope">
													<div v-if="scope.row.status == 1">In ProgressMedium</div>
													<div v-if="scope.row.status == 2">Approve</div>
													<div v-if="scope.row.status == 3">Reject</div>
												</template>
											</el-table-column>
											<el-table-column prop="remark" label="Comments" sortable />
											<el-table-column prop="apply_username" label="Task Owner" sortable />
											<el-table-column prop="end_time" label="Task Due Date" sortable />
										</el-table>
									</div>
									<div class="input_el" style="margin-top: 20px">
										<div class="tit required">CAPA Effectiveness ValidationResult</div>
										<el-form-item label="" prop="result">
											<el-input type="textarea" :rows="5" v-model="ruleForm.result" placeholder="Please enter" clearable></el-input>
										</el-form-item>
									</div>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">CAPA Effectiveness ValidationFile</div>
										</div>
										<el-table :data="actionTableData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Data">
											<el-table-column prop="" label="Description" sortable min-width="200">
												<template slot-scope="scope">
													<div>{{ scope.row.description || "/" }}</div>
												</template>
											</el-table-column>
											<el-table-column prop="fileName" label="File Name" min-width="240">
												<template slot-scope="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Operation" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<el-button type="primary" size="mini" style="margin: 10px"
											@click="handleActivityFile('ruleForm')">
											AddCAPA Effectiveness ValidationFile
										</el-button>
									</div>
									<!-- Bottom Buttons -->
									<div class="footer-btn">
										<el-button type="primary" size="small" @click="handleSaveLater('ruleForm')">
											Save for Later
										</el-button>
										<el-button type="primary" size="small" @click="handleSaveSign">
											Save and Continue to Sign
										</el-button>
										<el-button type="primary" size="small" @click="handleCancel">
											Cancel
										</el-button>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--SignatureDialog-->
		<el-dialog title="Action Implementation Approval Signature" :visible.sync="dialogVisible" width="30%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="0px">
						<div class="input_el">
							<div class="tit">Comments</div>
							<el-form-item label="" prop="remark">
								<el-input type="textarea" :rows="3" v-model="ruleForm1.remark" placeholder="Please enter"
									clearable></el-input>
							</el-form-item>
						</div>
						<div class="input_el">
							<div class="tit required">Password</div>
							<el-form-item label="" prop="signature">
								<el-input v-model="ruleForm1.signature" placeholder="Please enter" clearable
									show-password></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible = false">Cancel</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm1('ruleForm1')">Signature</van-button>
				</div>
			</div>
		</el-dialog>
		<!--SignatureDialog-->
		<!--AddFilePopup-->
		<el-dialog title="AddCAPA Effectiveness ValidationFile" :visible.sync="dialogVisible1" width="50%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form ref="ruleForm2" :model="ruleForm2" :rules="rules2" label-position="top" class="upload-form">
						<!-- Description -->
						<el-form-item label="Description" prop="description" required>
							<el-input v-model="ruleForm2.description" type="textarea" :rows="5" resize="none"
								placeholder="Please enterDescription" />
						</el-form-item>
						<!-- Attachments -->
						<el-form-item prop="">
							<div class="upload-doc-wrapper">
								<div class="upload-title required-title">
									<span> Files to Upload </span>
									<span class="upload-limit"> （Max 10 MB） </span>
								</div>
								<div class="upload-box" style="position: relative">
									<el-upload
										ref="uploadBox"
										class="doc-upload"
										action="/"
										name="files"
										:show-file-list="false"
										:before-upload="beforeAvatarUpload"
										:on-change="handleAvatarChange"
										:limit="1"
										:with-credentials="true"
										:auto-upload="false"
									>
										<el-button size="medium" class="select-btn">
											Select File
										</el-button>
									</el-upload>
									<div class="file-name" :class="{ placeholder: !fileName }">
										{{ fileName || "No File Selected" }}
										<span v-if="fileName" style="position: absolute; right: 20px; top: 12px; cursor: pointer;color: #f00;" @click="delFile">Delete</span>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible1 = false">
						Cancel
					</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm2('ruleForm2')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--AddFilePopup-->
	</div>
</template>

<script>
import {
	resourcesApplyDetail
} from "@/api/docManage/changeRequest/index";
import {
	ApplyHandle,
	capaVerificationResults,
	capaUploadsVerificationResultsFile,
	capaUploadsVerificationResultsFileDel
} from "@/api/capaManage/capaRequest/index";
import { usersList } from '@/api/system/user';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from 'js-md5';
import moment from 'moment';
export default {
	name: "CapaDetail",
	components: {
		headers,
		slider,
	},
	data() {
		return {
			showSolution: true,
			rootCauseExpanded: null,
			correctiveExpanded: null,
			allExpanded: false,
			info: {},
			dialogVisible: false,
			dialogVisible1: false,
			fileName: "",
			selectedFile: null,
			investigationLogTableData: [],
			rootCauseFiles: [],
			rootCause: [],
			affectedFiles: [],
			taskList: [],
			actionTableData: [],
			userToken: localStorage.getItem("userToken"),
			ruleForm: {
				result: "",
			},
			rules: {
				result: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}],
			},
			ruleForm1: {
				remark: "",
				signature: "",
			},
			rules1: {
				signature: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}],
			},
			ruleForm2: {
				description: "",
			},
			rules2: {
				description: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}],
			},
		};
	},
	computed: {
		//
	},
	mounted() {
		let that = this;
		that.step = that.$route.query.step;
		//Request Page Details
		resourcesApplyDetail({ id: that.$route.query.oid }).then(res => {
			if(res.code == 200) {
				// console.log(res.data);
				that.info = {
					...that.info,
					id: res.data.id,
					request_id: res.data.request_id,
					status_name: res.data.status_name,
					priority: res.data.priority,
					investigator: res.data.investigator,
					description: res.data.description,
					username: res.data.username,
					// company_name: res.data.company_name,
					source_type: res.data.source_type,
					departments_name: res.data.departments_name,
					source_info: res.data.source_info,
					time1: res.data.time1,
					time2: res.data.time2,
					time3: res.data.time3,
					time4: res.data.time4,
					time5: res.data.time5,
					time6: res.data.time6,
					pass_time: res.data.pass_time,
					step_name: res.data.step_name
				};
				// PopulateCAPABackgroundFile
				that.backdocTableData = res.data.capabackground_list || [];
				// Populate CorrectionFile
				that.correctionTableData = res.data.capacorrections_list || [];
				// Populate Affected Articles
				that.affectArticleTableData = res.data.capaarticle_list || [];
				// Activity Log
				that.investigationLogTableData = res.data.capaaffected_list || [];
				// Root Cause
				that.rootCause = res.data.caparootcause_list || [];
				that.actionTableData = res.data.capa_verification_results_list;
				that.ruleForm.result = res.data.capa_verification_results;
				that.taskList = res.data.capa_verification_apply_list;
				//Approval Records
				// that.historyTableData = res.data.apply_list;
			}
		});
	},
	methods: {
		//Initialize Time
		initTime(value) {
			return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss');
		},
		//Initialize Time
		initTime2(value) {
			return moment(value * 1000).format('YYYY-MM-DD');
		},
		handleSaveSign() {
			let that = this;
			that.dialogVisible = true;
		},
		// Save for Later
		handleSaveLater(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaVerificationResults({
					id: that.info.id,
					capa_verification_results: that.ruleForm.result
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation Successful');
						setTimeout(() => {
							window.location.reload();
						}, 800);
					}
				});
			});
		},
		handleAvatarChange(file, fileList) {  //Upload File
			let that = this;
			if (!file && !fileList) return;
			that.selectedFile = file.raw;
			that.fileName = file.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {  //Upload File
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if (!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed 10 MB");
				return false;
			}
			that.$toast.loading({
				duration: 0,
				forbidClick: true
			});
		},
		delFile() {  //DeleteFile
			let that = this;
			that.selectedFile = null;
			that.fileName = '';
			that.$refs.uploadBox.clearFiles();
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		// AddCAPA Effectiveness ValidationFile
		handleActivityFile(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaVerificationResults({
					id: that.info.id,
					capa_verification_results: that.ruleForm.result
				}).then(res => {
					if(res.code == 200) {
						that.dialogVisible1 = true;
					}
				});
			});
		},
		// Signature
		submitForm1(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				ApplyHandle({
					id: that.$route.query.oid,
					status: 2,
					remark: that.ruleForm1.remark,
					signature: md5(that.ruleForm1.signature+'AiisoQms2026')
				}).then(res2 => {
					if(res2.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation Successful');
						setTimeout(() => {
							that.$router.push({ path: '/task-list' });
						}, 800);
					}
				});
			});
		},
		// AddCAPA Effectiveness ValidationFileConfirm
		submitForm2(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (!valid) return;
				if (!that.selectedFile) {
					that.$message.warning("Please upload a file");
					return false;
				}
				that.$toast.loading({ duration: 0, forbidClick: true });
				const formData = new FormData();
				formData.append('files', that.selectedFile);
				formData.append('description', that.ruleForm2.description);
				formData.append('capa_id', that.info.id);
				formData.append('id', '');
				capaUploadsVerificationResultsFile(formData).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation Successful');
						setTimeout(() => {
							window.location.reload();
						}, 800);
					}
				});
			});
		},
		//DeleteFile
		handleRemove(value) {
			let that = this;
			that.$confirm("ConfirmDeletethisAttachments?？", "Notice", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaUploadsVerificationResultsFileDel({ id: value.id }).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation Successful");
						setTimeout(() => {
							window.location.reload();
						}, 800);
					}
				});
			}).catch(() => {});
		},
		//Expand & Hide All
		toggleAll() {
			let that = this;
			that.allExpanded = !that.allExpanded;
			if(!that.allExpanded) {
				that.rootCauseExpanded = null;
				that.correctiveExpanded = null;
			}
		},
		//Expand & Hide
		rootCauseExpandedClick(value) {
			let that = this;
			if(that.rootCauseExpanded == value.id) {
				that.rootCauseExpanded = null;
			}else {
				that.rootCauseExpanded = value.id;
			}
		},
		correctiveExpandedClick(value) {
			let that = this;
			if(that.correctiveExpanded == value.id) {
				that.correctiveExpanded = null;
			}else {
				that.correctiveExpanded = value.id;
			}
		},
	},
};
</script>

<style lang="less" scoped>
	.save_box {
		.btn_box {
			text-align: right;

			.btn_el {
				margin-left: 10px;
				padding: 12px 24px;

				.van-button__text {
					font-size: 16px;
				}
			}
		}

		.form_box {
			.input_el {
				.tit {
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}

				.required::before {
					content: "*";
					color: red;
					margin-right: 2px;
				}

				.full-width {
					width: 100%;
				}
			}
		}
	}

	//Main Content
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//Header
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>

<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 28px;
		align-items: start;
	}

	.form-col {
		display: flex;
		flex-direction: column;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* label Style */
	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}

	/* Unified Input Style */
	.gray-input {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		padding-left: 15px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.text-tip {
		background-color: #fafafa;
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.custom-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 10px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.table-title {
		font-size: 18px;
		font-weight: 700;
		color: #2f343b;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.solution-plan {
		width: 100%;
		color: #303133;
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.plan-header {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.plan-title {
		font-size: 20px;
		font-weight: 700;
		color: #1f2d3d;
		margin-right: 8px;
	}

	.toggle-btn {
		padding: 0;
		font-size: 13px;
	}

	.plan-card {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		background: #fff;
		overflow: hidden;
	}

	.plan-section {
		padding: 28px 20px 18px;
	}

	.section-title {
		margin: 0 0 26px;
		font-size: 24px;
		font-weight: 700;
		color: #303133;
	}

	.sub-title {
		font-size: 20px;
		font-weight: 700;
		color: #303133;
		margin-bottom: 20px;
	}

	.form-block {
		margin-bottom: 10px;
	}

	.field-label {
		display: block;
		margin-bottom: 5px;
		font-size: 14px;
		font-weight: 700;
		color: #303133;
	}

	.section-toggle {
		margin-top: 12px;
	}

	.section-toggle .el-button {
		padding: 0;
		font-size: 14px;
		font-weight: 600;
	}

	.upload-doc-wrapper {
		width: 100%;
		margin-bottom: 40px;
		box-sizing: border-box;
	}

	.upload-title {
		font-size: 16px;
		color: #333;
		margin-bottom: 14px;
		font-weight: 500;
	}

	.required-title {
		position: relative;
		padding-left: 10px;
	}

	.required-title::before {
		content: "*";
		position: absolute;
		left: 0;
		top: 3px;
		color: #f56c6c;
		font-size: 15px;
	}

	.upload-limit {
		color: #666;
		font-weight: 400;
	}

	.upload-box {
		display: flex;
		align-items: center;
		width: 100%;
		height: 44px;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		overflow: hidden;
		background: #f5f7fa;
	}

	.doc-upload {
		flex-shrink: 0;
	}

	.file-name {
		flex: 1;
		height: 44px;
		line-height: 44px;
		padding: 0 16px;
		font-size: 15px;
		color: #333;
		background: #f5f7fa;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: relative;
	}

	.file-name.placeholder {
		color: #999;
	}

	.divider {
		height: 1px;
		background: #ebeef5;
	}

	.custom-table {
		margin-bottom: 14px;
		width: 100%;
	}

	.el-icon-arrow-down,
	.el-icon-arrow-up {
		margin-left: 2px;
	}

	.footer-btn {
		display: flex;
		margin-top: 50px;
		justify-content: center;
		align-self: center;
	}

	.tit {
		padding-bottom: 5px;
		font-size: 14px;
		color: #333333;
	}

	.required::before {
		content: "*";
		color: red;
		margin-right: 2px;
	}
</style>